import cx from 'classnames';
import { SEARCH_IN_FORUM, SEARCH_RESULTS_FOR } from 'mk/autogenerated/translations/ForumSearch.17cea0263770bbe8ba464632e9d97793'
import { GCSE_CX } from 'mk/settings';
import { Props } from 'mk2/apps/forum/containers/ForumSearch/ForumSearchPage';
import SearchBox from 'mk2/components/SearchBox';
import React from 'react';
import styles from './ForumSearch.mscss';

declare const google;

class ForumSearch extends React.Component<Props> {

    private results: HTMLDivElement;
    private gname = 'forum-results';

    public componentDidMount() {
        const { queryFromUrl, queryFromState, onSearchUpdate, onSearchSave } = this.props;

        // Save search on the server
        if (queryFromUrl && queryFromUrl !== queryFromState) {
            onSearchUpdate(queryFromUrl);
        } else if (queryFromUrl) {
            onSearchSave(queryFromUrl);
        }

        // Mount cse
        const scripttag = document.querySelector('script#cse');
        if (!scripttag) {
            (window as any).__gcse = {
                parsetags: 'explicit',
                callback: this.renderResults,
            };

            const gcse: HTMLScriptElement = document.createElement('script');
            gcse.id = 'cse';
            gcse.type = 'text/javascript';
            gcse.async = true;
            gcse.src = 'https://cse.google.com/cse.js?cx=' + GCSE_CX;
            const s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gcse, s);
        } else {
            this.renderResults();
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const { queryFromState, queryFromUrl, onSearchUpdate, onSearchSave } = this.props;

        if (queryFromUrl !== prevProps.queryFromUrl) {
            if (queryFromUrl !== queryFromState) {
                onSearchUpdate(queryFromUrl);
            } else {
                if (queryFromUrl) {
                    onSearchSave(queryFromUrl);
                }

                this.updateResults();
            }
        }
    }

    public componentWillUnmount() {
        // Clear search in the state
        const { onSearchUpdate } = this.props;
        onSearchUpdate('');
    }

    public render() {
        const { className, queryFromState, queryFromUrl, onSearch, onSearchUpdate } = this.props;

        return (
            <div className={cx(styles.ForumSearch, className)}>
                <SearchBox
                    query={queryFromState}
                    placeholder={SEARCH_IN_FORUM}
                    onChange={onSearchUpdate}
                    onSubmit={onSearch}
                    autoFocus="end"
                    noClear
                />

                {queryFromUrl ? (
                    <h2 className={styles.ForumSearch__headline}>
                        {SEARCH_RESULTS_FOR}
                        {' '}
                        <span>&ldquo;{queryFromUrl}&rdquo;</span>
                    </h2>
                ) : null}

                <div
                    className={cx(styles.ForumSearch__results, !queryFromUrl && styles['ForumSearch__results--empty'])}
                    ref={(r) => this.results = r}
                />
            </div>
        );
    }

    private renderResults = () => {
        if (typeof google === 'undefined') {
            // cse is not loaded yet
            return;
        }

        if (document.readyState === 'complete') {
            this.gcseRender();
        } else {
            google.setOnLoadCallback(this.gcseRender);
        }
    };

    private updateResults = () => {
        if (typeof google === 'undefined') {
            // cse is not loaded yet
            return;
        }

        const { queryFromUrl } = this.props;
        const element = google.search.cse.element.getElement(this.gname);
        if (element && element.getInputQuery() !== queryFromUrl) {
            if (queryFromUrl) {
                element.execute(queryFromUrl);
            } else {
                element.clearAllResults();
            }
        }
    };

    private gcseRender = () => {
        google.search.cse.element.render({
            div: this.results,
            tag: 'searchresults-only',
            gname: this.gname,
        });
        this.updateResults();
    };
}

export default ForumSearch;
